var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserbig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#2A2A2A",
    d: "m20.44848,11.59756c0,1.49184 -0.5926,2.92258 -1.64752,3.9775c-1.0549,1.0549 -2.48564,1.6475 -3.97748,1.6475c-1.49184,0 -2.92258,-0.5926 -3.97748,-1.6475c-1.05489,-1.05492 -1.64752,-2.48566 -1.64752,-3.9775c0,-1.49184 0.59263,-2.92258 1.64752,-3.97748c1.0549,-1.05489 2.48564,-1.64752 3.97748,-1.64752c1.49184,0 2.92258,0.59263 3.97748,1.64752c1.05492,1.0549 1.64752,2.48564 1.64752,3.97748z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#2A2A2A",
    d: "m0,15c0,-3.9782 1.58035,-7.79356 4.3934,-10.6066c2.81304,-2.81305 6.6284,-4.3934 10.6066,-4.3934c3.9782,0 7.7936,1.58035 10.6066,4.3934c2.813,2.81304 4.3934,6.6284 4.3934,10.6066c0,3.9782 -1.5804,7.7936 -4.3934,10.6066c-2.813,2.813 -6.6284,4.3934 -10.6066,4.3934c-3.9782,0 -7.79356,-1.5804 -10.6066,-4.3934c-2.81305,-2.813 -4.3934,-6.6284 -4.3934,-10.6066zm15,-13.125c-2.4717,0.00013 -4.8931,0.69818 -6.98549,2.0138c-2.09244,1.31562 -3.77085,3.19534 -4.84208,5.42281c-1.07122,2.22749 -1.49171,4.71219 -1.21306,7.16809c0.27865,2.4559 1.2451,4.7832 2.78813,6.7141c1.33125,-2.1451 4.26188,-4.4438 10.2525,-4.4438c5.9906,0 8.9194,2.2969 10.2525,4.4438c1.543,-1.9309 2.5095,-4.2582 2.7881,-6.7141c0.2787,-2.4559 -0.1418,-4.9406 -1.213,-7.16809c-1.0713,-2.22747 -2.7497,-4.10719 -4.8421,-5.42281c-2.0924,-1.31562 -4.5138,-2.01367 -6.9855,-2.0138z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserbig);
export default __webpack_public_path__ + "static/media/userbig.7f9a0d7b0384dbe335fd175a50c734f0.svg";
export { ForwardRef as ReactComponent };